'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Controller($scope, $filter, $window, CurrencyComponent, PageHeading, Toast) {
	'ngInject';

	var vm = this;
	vm.getCurrencies = CurrencyComponent.getCurrencies;
	vm.deleteCurrency = deleteCurrency;
	// vm.setDefault = setDafault;
	vm.setBaseCurrency = setBaseCurrency();
	vm.baseCurrency = '';

	setBaseCurrency();
	activate();

	function activate() {
		var heading = $filter('translate')('SIDEBAR.CURRENCIES');
		var title = 'BTMS | ' + $filter('translate')('SIDEBAR.CURRENCIES');

		PageHeading.setPageHeading(heading, title);
	}

	function deleteCurrency(id) {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			CurrencyComponent.deleteCurrency(id).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.DELETE_CURRENCY'));
					CurrencyComponent.fetchCurrencies();
				}
			});
		}
	}

	/** */
	// function setDafault(currency) {

	// 	CurrencyComponent.setDefault(currency)
	// 		.then(function (res) {

	// 			if (res.data.errors) {
	// 				Toast.responseError(res.data.errors);
	// 			}

	// 			CurrencyComponent.fetchCurrencies()
	// 				.then(function() {
	// 					setBaseCurrency( currency.code );
	// 					Toast.success(`${ $filter('translate')('SET_BASE_CURRENCY')} ${currency.code}`);
	// 				});
	// 		});
	// }

	/** */
	function setBaseCurrency(code) {
		if (code) {
			vm.baseCurrency = code;
			return vm.baseCurrency;
		} else {
			angular.forEach(vm.getCurrencies(), function (currency) {
				if (currency.is_base === true) {
					vm.baseCurrency = currency.code;
					return vm.baseCurrency;
				}
			});
		}
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/currencies/list/list.controller.js
 **/